<template>
  <div class="page-container">
    asd
    <!-- Content Wrapper START -->
    <div class="main-content">
      <pageheader page-name="1868s" />
      <div class="card">
        <div class="card-body">
          <div class="m-t-25">
            <div class="row">
              <div class="col-lg-12 add-form mb-4 d-flex justify-content-end">
                <router-link :to="`/1868/add`">
                  <button class="btn btn-info">Add New 1868</button>
                </router-link>
              </div>
            </div>
            <section v-if="!isLoading">
              <datatable :fields="fields" :items="items"/>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
/* eslint-disable no-undef */
import Pageheader from '@/components/Pageheader.vue'
import Datatable from '@/components/Datatable.vue'
export default {
  name: 'C1868s',
  data () {
    return {
      API_BASE_URL: 'c1868',
      items: [],
      fields: [
        { label: 'Name', key: 'name' },
        { label: 'C1868 #', key: 'c1868_no' },
        { label: 'Category', key: 'categoryName' },
        { label: 'Enabled', key: 'is_enabled' },
        { label: 'Sort #', key: 'sort_no' },
        { label: 'Downloads', key: 'downloads' },
        {
          label: 'Action',
          key: 'action',
          actions: {
            edit: {
              name: 'EditC1868'
            },
            remove: (id) => this.remove(id)
          }
        }
      ]
    }
  },
  computed: {
    isLoading () {
      if (this.items.length === 0) {
        return this.$store.getters[this.API_BASE_URL + '/apiLoading']
      } else { return false }
    }
  },
  mounted () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.items = []
      console.log(this.API_BASE_URL + '/all')
      this.$store.dispatch(this.API_BASE_URL + '/all')
        .then((result) => {
          result.c1868s.forEach(item => {
            this.items.push(item)
          })
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    remove (id) {
      this.$confirm({
        message: `Are you sure you want to delete this c1868?`,
        button: { no: 'No', yes: 'Yes' },
        callback: confirm => {
          if (confirm) {
            this.$store.dispatch(this.API_BASE_URL + '/delete', id)
              .then((result) => {
                this.$toast.success(result.data.message)
                this.fetchAll()
              })
              .catch((err) => this.$toast.error(err.response.data.message))
          }
        }
      })
    }
  },
  components: { Pageheader, Datatable }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/C1868s/index.vue